import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { AuthenticationResetPasswordComponent } from './authentication-reset-password/authentication-reset-password.component';
import { AuthService } from '@app/services';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { DivVisibilityService } from '@app/services/div-visibility/div-visibility.service';

interface QueryParamsApp {
   /** Código para  */
   c?: string;

   m?: string;
}

@Component({
   templateUrl: './authentication.component.html',
   styleUrls: ['./authentication.component.scss'],
   encapsulation: ViewEncapsulation.None,
})
export class AuthenticationComponent implements OnInit, OnDestroy {
   subs: { [prop: string]: Subscription } = {};

   imagesMorning = [
      'https://static.monific.com/assets/assets-app/images/morning-1.jpg',
      'https://static.monific.com/assets/assets-app/images/morning-2.jpg',
      'https://static.monific.com/assets/assets-app/images/morning-3.jpg',
      'https://static.monific.com/assets/assets-app/images/morning-4.jpg',
      'https://static.monific.com/assets/assets-app/images/morning-5.jpg',
   ];

   imagesAfternoon = [
      'https://static.monific.com/assets/assets-app/images/afternoon-1.jpg',
      'https://static.monific.com/assets/assets-app/images/afternoon-2.jpg',
      'https://static.monific.com/assets/assets-app/images/afternoon-3.jpg',
      'https://static.monific.com/assets/assets-app/images/afternoon-4.jpg',
   ];

   imagesNight = [
      'https://static.monific.com/assets/assets-app/images/afternoon-1.jpg',
      'https://static.monific.com/assets/assets-app/images/afternoon-2.jpg',
   ];

   testimonies = [
      { name: 'Roxana Folado', description: 'Para mí el éxito en una inversión implica recibir renta vitalicia. Me gusta que Monific contribuye a ello y hace accesible a más personas la posibilidad de invertir.' },
      { name: 'Sofia Salame', description: 'Mi experiencia con Monific ha sido increíble. Desde el inicio, la información fue clara y me permitió tomar decisiones inteligentes. Me siento segura y satisfecha con mis inversiones.' },
      { name: 'Obed Lucio Contrera', description: 'Tengo alrededor de 3 años que inicie a invertir en Monific, mi experiencia ha sido muy positiva, la claridad y simpleza en el uso de la plataforma ha sido clave. Ademas la constante comunicación por parte de la compañía ha ayudado a la confianza. Su cumplimiento en las expectativas para mi ha sido elemental para seguir creciendo mis inversiones en Monific.' },
      { name: 'Herminia Méndez', description: 'En el tiempo que llevo Los rendimientos llegan de manera puntual.' },
      { name: 'Vidalina Baltazar', description: 'Invertir en monific me ha ayudado a organizar mis gastos. Y por supuesto estoy confiada en que los proyectos darán buenos resultados.' }
   ]

   imgBanner: SafeUrl;

   showBannerInit: boolean = true;

   isVisible = true;

   path: 'login' | 'register';

   customOptions: OwlOptions = {
      margin: 10,
      loop: true,
      dots: true,
      nav: true,
      mouseDrag: true,
      touchDrag: true,
      pullDrag: true,
      autoplay: true,
      navSpeed: 700,
      responsive: {
         0: {
            items: 1,
         },
         600: {
            items: 1,
         },
         1000: {
            items: 1,
         }
      },
   };

   constructor(
      private readonly authServ: AuthService,
      private readonly dialog: MatDialog,
      private readonly router: Router,
      private readonly activatedRoute: ActivatedRoute,
      private readonly divVisibilityService: DivVisibilityService ) {

      this.subs.a = router.events.pipe(
         filter(e => e instanceof NavigationEnd))
         .subscribe((r) => {
            this.path = (r as NavigationEnd).url === '' ? 'login' : 'register';
         });

      this.subs.b = this.activatedRoute.queryParams.subscribe((params: QueryParamsApp) => {
         if (params.c && params.m) this.validateResetPasswordToken(params.c, params.m);
      });

      this.showBannerInit = this.showBannerDetect();

      this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.showBannerInit = this.showBannerDetect();
      });

   }



   ngOnInit(): void {
      this.divVisibilityService.visibility$.subscribe(
         isVisible => this.isVisible = isVisible
       );
   }

   validateResetPasswordToken(c: string, m: string) {
      this.authServ.validateToken({ c, m }).subscribe({
         next: () => {
            const modal = this.dialog.open(AuthenticationResetPasswordComponent, {
               width: '95vw',
               maxWidth: '500px',
               disableClose: true,
               autoFocus: false,
               maxHeight: '95vh',
               panelClass: 'mnf-modal-container',
            })

            modal.componentInstance.token = c;
            modal.componentInstance.email = m;
         }
      });
   }

   showBannerDetect(): boolean {
      const url = this.router.url;
      if (url === '/') {
        return true;
      } else if (url === '/registro') {
        return false;
      } else {
        if(url.startsWith('/?')) {
         return true
        }
      }
      return true;
    }


   items = [
      { imagen: 'https://static.monific.com/assets/assets-app/sliders/slider_5.svg', icon: 'https://static.monific.com/assets/assets-app/sliders/key-icon.svg' , subtitle: 'Oportunidades a tu alcance', texto: 'Invierte de forma fácil, segura y accesible en proyectos inmobiliarios seleccionados.' },
      { imagen: 'https://static.monific.com/assets/assets-app/sliders/slider_6.svg', icon: 'https://static.monific.com/assets/assets-app/sliders/wallet-icon.svg' , subtitle: 'Genera rendimientos atractivos', texto: 'Obtén rendimientos anuales fijos desde 15%. ¡Tu inversión respaldada por inmuebles!' },
      { imagen: 'https://static.monific.com/assets/assets-app/sliders/slider_7.svg', icon: 'https://static.monific.com/assets/assets-app/sliders/pencil-icon.svg', subtitle: '¡Tu camino hacia la libertad financiera! ', texto: 'Genera ingresos mientras disfrutas de tu tiempo libre. Explora las oportunidades y comienza a crear un futuro financiero sólido.'},
   ];

   ngOnDestroy(): void {
      this.subs.a.unsubscribe();
      this.subs.b.unsubscribe();
   }
}
